<template>
  <div>
    <div ref="sankeyChart" style="width: 100%; height: 600px; margin-top: 80px;"></div>
    <el-button type="primary" @click="downloadChart">下载图表</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sankeyChart: null,
    };
  },
  mounted() {
    this.renderSankeyChart();
  },
  methods: {
    renderSankeyChart() {
      this.sankeyChart = this.$echarts.init(this.$refs.sankeyChart);
      const data = [
        { source: 'NPAS', target: 'En_KIT_464', value: 3 },
        { source: 'NPAS', target: 'En_PS_597', value: 3 },
        { source: 'NPAS', target: 'En_RS_429', value: 3 },
        { source: 'NPAS', target: 'En_Thy1_421', value: 3 },
        { source: 'SF1', target: 'En_KIT_464', value: 3 },
        { source: 'SF1', target: 'En_PS_597', value: 3 },
        { source: 'SF1', target: 'En_RS_429', value: 3 },
        { source: 'SF1', target: 'En_Thy1_421', value: 3 },
        { source: 'En_KIT_464', target: 'Malat1', value: 6 },
        { source: 'En_PS_597', target: 'Malat1', value: 6 },
        { source: 'En_RS_429', target: 'Malat1', value: 6 },
        { source: 'En_Thy1_421', target: 'Malat1', value: 6 },
        { source: 'FOXO3', target: 'En_RS_824', value: 3 },
        { source: 'FOXO3', target: 'En_PS_980', value: 3 },
        { source: 'En_RS_824', target: 'Abca16', value: 3 },
        { source: 'En_PS_980', target: 'Abca16', value: 3 },
        { source: 'En_KIT_861', target: 'Abca16', value: 27 },
        { source: 'TEAD3', target: 'En_KIT_861', value: 3 },
        { source: 'TEAD1', target: 'En_KIT_861', value: 3 },
        { source: 'NPAS', target: 'En_KIT_861', value: 3 },
        { source: 'PITX1', target: 'En_KIT_861', value: 3 },
        { source: 'TWIST2', target: 'En_KIT_861', value: 3 },
        { source: 'ZNF416', target: 'En_KIT_861', value: 3 },
        { source: 'HEB', target: 'En_KIT_861', value: 3 },
        { source: 'LRF', target: 'En_KIT_861', value: 3 },
        { source: 'E2A', target: 'En_KIT_861', value: 3 }
      ];
      const nodes = [];
      data.forEach(item => {
        if (!nodes.includes(item.source)) {
          nodes.push(item.source);
        }
        if (!nodes.includes(item.target)) {
          nodes.push(item.target);
        }
      });
      const option = {
        tooltip: {},
        series: {
          type: 'sankey',
          layout: 'none',
          focusNodeAdjacency: 'allEdges',
          data: nodes.map(name => ({ name })),
          links: data.map(item => ({
            source: item.source,
            target: item.target,
            value: item.value
          })),
          itemStyle: {
            borderWidth: 1,
            borderColor: '#aaa'
          },
          lineStyle: {
            color: 'source',
            opacity: 0.6
          }
        }
      };
      this.sankeyChart.setOption(option);
    },
    downloadChart() {
      // Check if the chart instance is available
      if (!this.sankeyChart) {
        console.error('Sankey chart instance is not available');
        return;
      }
      // Convert chart to base64 image
      const base64Data = this.sankeyChart.getDataURL({
        type: 'png',
        pixelRatio: 2, // Increase pixel ratio for better resolution
      });
      // Create a temporary link element to trigger the download
      const link = document.createElement('a');
      link.href = base64Data;
      link.download = 'sankey_chart.png';
      link.click();
    }
  }
};
</script>

<style scoped>
/* Add your custom styles here */
</style>
  


// WEBPACK FOOTER //
// src/components/Test.vue